module.exports = __webpack_public_path__ + "img/Lot3.24119c7f.jpg";